// extracted by mini-css-extract-plugin
export var container = "_gk-0";
export var icon = "_gk-1";
export var text = "_gk-2";